import Icon from '../components/Icon.vue'

Icon.register({
  'star-of-david': {
    width: 464,
    height: 512,
    paths: [
      {
        d: 'M405.7 256L458.9 166.6C473.3 142.4 455.5 112 426.9 112H320L264 18C256.9 6 244.4 0 232 0S207.1 6 200 18L144 112H37.1C8.5 112-9.3 142.4 5.1 166.6L58.3 256 5.1 345.4C-9.3 369.6 8.5 400 37.1 400H144L200 494C207.1 506 219.6 512 232 512S256.9 506 264 494L320 400H426.9C455.5 400 473.3 369.6 458.9 345.4L405.7 256zM392.9 168L373.1 201.3 353.3 168H392.9zM340.5 256L288.1 344H175.9L123.5 256 175.9 168H288.1L340.5 256zM232 73.7L254.8 112H209.2L232 73.7zM71.1 168H110.7L90.9 201.3 71.1 168zM71.1 344L90.9 310.7 110.7 344H71.1zM232 438.3L209.2 400H254.8L232 438.3zM353.3 344L373.1 310.7 392.9 344H353.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-of-david.js
// module id = rB6C
// module chunks = 144